module.exports = __webpack_public_path__ + "static/media/B47568E4-38CB-4B20-A127-B4109AB6E852.d59f81d5.jpeg";